import { getGlobalThis, loadScript } from "@crystal/core/utils";
import { Queue } from "./queue.js";
import { isServer } from "./utils.js";
const instanaScriptUrl = "https://eum.instana.io/eum.min.js";
const queue = new Queue("instana", isInstanaReady, (item) => {
  const { ineum } = getGlobalThis();
  ineum(item.command, ...item.args);
});
function logInstana(command, ...args) {
  if (isServer())
    return;
  if (isInstanaReady()) {
    const { ineum } = getGlobalThis();
    return ineum(command, ...args);
  }
  queue.add({
    command,
    args
  });
  queue.tryCommit();
}
function isInstanaReady() {
  const win = getGlobalThis();
  return !!win.ineum;
}
const instana = logInstana;
function isInstanaPending() {
  return !queue.isEmpty();
}
function clearInstanaQueue() {
  queue.clear();
}
function loadInstanaAgent({ key, reportingUrl, trackSessions = true }) {
  if (isInstanaReady()) {
    return Promise.resolve();
  }
  (function(s, t, a, n) {
    s[t] || (s[t] = a, n = s[a] = function() {
      n.q.push(arguments);
    }, n.q = [], n.v = 2, n.l = 1 * /* @__PURE__ */ new Date());
  })(window, "InstanaEumObject", "ineum");
  const { ineum } = getGlobalThis();
  ineum("reportingUrl", reportingUrl);
  ineum("key", key);
  if (trackSessions) {
    ineum("trackSessions");
  }
  return loadScript(instanaScriptUrl, "instana-agent-loader");
}
export {
  clearInstanaQueue,
  instana,
  isInstanaPending,
  isInstanaReady,
  loadInstanaAgent
};
//# sourceMappingURL=instana.js.map
